import { useEffect, useMemo, useState } from 'react';
import { useTemplate } from '../../../../../features/template/TemplateProvider';
import { ButtonCancel, ButtonPrimary } from '../../../../../utils/Button';
import FocusControl from '../../../../../utils/FocusControl';
import { InputNumberField, SelectOption, addOption } from '../../../../../utils/InputField';
import cn from '../../../../../utils/cn';
import { ApiCreateServicePackagePricing } from '../../../Services/ServiceOperation';
import { ApiGetAllServicesPackage } from '../../ProductOperation';

const initialData = {
    ApplicationId: 0,
    AppServiceId: 0,
    PackageId: 0,
    Currency: '',
    Amount: 0,
    VatPercent: 0,
    Status: 'active'
};

function AddPackageServiceModal({ closeModal, handleReload, data }) {
    const [formData, setFormData] = useState({ Id: data?.id, ...initialData });
    const [serviceData, setServiceData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [isFree, setIsFree] = useState(false);
    const [isError, setIsError] = useState('');
    const { setMessage } = useTemplate();
    // -- Load Service Data
    useEffect(() => {
        // Fetch Service Data
        ApiGetAllServicesPackage(data?.role)
            .then(({ data: resData }) => {
                setServiceData(resData.services);
            })
            .catch((error) => {
                setMessage({ type: 'error', text: error.toString(0) });
            });
    }, [data?.role]);
    // -- Handle Change
    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name) {
            setFormData((prevData) => ({ ...prevData, [name]: value }));
        }
    };
    const handleFree = (e) => {
        if (e.target.checked) {
            setIsFree(true);
            setFormData((prevData) => ({ ...prevData, Amount: 'Free' }));
        } else {
            setIsFree(false);
            setFormData((prevData) => ({ ...prevData, Amount: 0 }));
        }
    };
    const payload = useMemo(() => {
        const appServiceId = serviceData?.find(
            (item) => item.packageId === Number(formData.PackageId)
        );
        if (isFree) {
            return {
                ...formData,
                ApplicationId: data?.applicationId,
                ApplicationPackageId: data?.id,
                AppServiceId: appServiceId?.appServiceId || 0,
                PackageId: Number(formData.PackageId),
                Amount: -102
            };
        }

        return {
            ...formData,
            ApplicationId: data?.applicationId,
            ApplicationPackageId: data?.id,
            AppServiceId: appServiceId?.appServiceId || 0,
            PackageId: Number(formData.PackageId),
            Amount: Number(formData.Amount)
        };
    }, [data, formData, isFree, serviceData]);

    const handleAdd = (e) => {
        setLoading(true);
        e.preventDefault();
        ApiCreateServicePackagePricing(payload.AppServiceId, payload.PackageId, payload, setIsError)
            .then(({ title }) => {
                setLoading(false);
                setMessage({ type: 'success', text: title });
                closeModal();
                handleReload();
            })
            .catch((error) => {
                setLoading(false);
                setMessage({ type: 'error', text: error.toString(0) });
            });
    };

    FocusControl(isError, setIsError, formData);
    return (
        <form
            onSubmit={handleAdd}
            className="product_package_service_price_form flex flex-col gap-4"
        >
            <SelectOption
                label="Service"
                name="PackageId"
                formData={formData}
                onChange={handleChange}
                options={serviceData?.map((item) =>
                    addOption(
                        item?.packageId,
                        `${item.serviceTitle} (${item.packageName})`,
                        item?.packageId
                    )
                )}
                required
            />

            <SelectOption
                label="Currency"
                name="Currency"
                formData={formData}
                onChange={handleChange}
                options={['thb', 'usd', 'eur', 'bdt']?.map((item) =>
                    addOption(item, item?.toUpperCase(), item)
                )}
                required
            />
            <div className="flex gap-3">
                <div className={cn('flex flex-col w-full custom-field relative')}>
                    <div className="flex justify-between items-center pl-1 mb-1 text-sm md:text-base capitalize w-full font-normal text-left">
                        <span>
                            Amount <span className="text-error"> *</span>
                        </span>
                        <label className="flex justify-between items-center gap-2">
                            <span>Free</span>
                            <input
                                type="checkbox"
                                name="isFree"
                                onChange={handleFree}
                                className="mr-1"
                            />
                        </label>
                    </div>
                    <input
                        type="text"
                        name="Amount"
                        value={formData.Amount}
                        onChange={handleChange}
                        placeholder="Amount"
                        readOnly={isFree}
                        autoComplete="off"
                        className={cn(
                            `flex-shrink w-full h-8.5 md:h-10 bg-transparent rounded-lg block outline-none border border-primary-200 px-2 text-primary text-xs md:text-sm leading-6 font-normal read-only:border-primary-100 read-only:bg-primary-50/50 read-only:text-primary-700 read-only:cursor-default`
                        )}
                    />
                </div>
                <InputNumberField
                    label="Vat(%)"
                    name="VatPercent"
                    placeholder="Type Vat(%)..."
                    formData={formData}
                    onChange={handleChange}
                />
            </div>
            <div className="flex gap-x-2 justify-end">
                <ButtonCancel title="Cancel" onClick={closeModal} />
                <ButtonPrimary title="Add" btnType="submit" loading={loading} />
            </div>
        </form>
    );
}

export default AddPackageServiceModal;
